<div class="d-flex justify-center align-center h-full p-3">
    <mat-card class="w-full" style="max-width: 950px;">
        <mat-card-header></mat-card-header>
        <mat-card-content class="p-4">
            <div class="layout-grid cols-2 gap-4">
                <!-- Columna de Logos -->
                <div class="flex-column align-center">
                    <div class="w-full d-flex justify-start">
                        <img ngSrc="SAT_provedor_autorizado.png" priority width="80" height="80"
                            alt="SAT Proveedor Autorizado">
                    </div>
                    <div style="margin-top: -50px;">
                        <img ngSrc="ntlink_world.png" priority width="350" height="350" alt="NtLink World Logo">
                    </div>
                    <div class="text-center magistral" style="margin-top: -50px;">
                        <h4><span class="mat-primary-text">Portal Web Service - Registro</span></h4>
                    </div>
                </div>

                <!-- Columna de Formulario -->
                <div class="flex-column">
                    <div class="d-flex justify-between align-center mb-3">
                        <h4><span class="mat-primary-text magistral">Crear cuenta</span></h4>
                        <div class="d-flex gap-2">
                            <app-climate-toggle></app-climate-toggle>
                            <app-palette-picker></app-palette-picker>
                        </div>
                    </div>

                    <!-- Step 1: Registro -->
                    <form *ngIf="step === 1" #registerForm="ngForm" (ngSubmit)="register(registerForm)"
                        class="flex-column">


                        <div class="layout-grid cols-2">
                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>Nombre</mat-label>
                                <input matInput placeholder="Razon Social/Nombre" [(ngModel)]="name" name="name"
                                    #nameModel="ngModel" required minlength="3" maxlength="100">
                                @if (nameModel.invalid && (nameModel.touched || registerForm.submitted)) {
                                    <mat-error>
                                        @if (nameModel.hasError('required')) {
                                            El nombre es requerido.
                                        } @else if (nameModel.hasError('minlength')) {
                                            El nombre debe tener al menos 3 caracteres.
                                        }
                                    </mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>Correo</mat-label>
                                <input matInput type="email" placeholder="Correo" [(ngModel)]="email" name="email"
                                    #emailModel="ngModel" required email maxlength="150">
                                @if (emailModel.invalid && (emailModel.touched || registerForm.submitted)) {
                                    <mat-error>
                                        @if (emailModel.hasError('required')) {
                                            El correo es requerido.
                                        } @else if (emailModel.hasError('email')) {
                                            Ingrese un correo válido.
                                        }
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>

                        <div class="layout-grid cols-2">
                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>Teléfono</mat-label>
                                <input matInput type="tel" placeholder="Teléfono" [(ngModel)]="phone" name="phone"
                                    #phoneModel="ngModel" required pattern="^[0-9]{10}$">
                                @if (phoneModel.invalid && (phoneModel.touched || registerForm.submitted)) {
                                    <mat-error>
                                        @if (phoneModel.hasError('required')) {
                                            El teléfono es requerido.
                                        } @else if (phoneModel.hasError('pattern')) {
                                            Ingrese un teléfono de 10 dígitos.
                                        }
                                    </mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>RFC</mat-label>
                                <input matInput placeholder="RFC" [(ngModel)]="rfc" name="rfc" #rfcModel="ngModel"
                                    required minlength="12" maxlength="13"
                                    pattern="^[A-Za-z&Ññ]{3,4}[0-9]{6}[A-Za-z0-9]{3}$">
                                @if (rfcModel.invalid && (rfcModel.touched || registerForm.submitted)) {
                                    <mat-error>
                                        @if (rfcModel.hasError('required')) {
                                            El RFC es requerido.
                                        } @else if (rfcModel.hasError('minlength') || rfcModel.hasError('maxlength') ||
                                        rfcModel.hasError('pattern')) {
                                            Ingrese un RFC válido (12 o 13 caracteres).
                                        }
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>

                        <div class="d-flex justify-center mt-4">
                            <button mat-raised-button [color]="registerForm.invalid ? 'secondary' : 'primary'" type="submit" class="px-5"
                                [disabled]="registerForm.invalid || loading">Registrarme</button>
                        </div>
                    </form>

                    <!-- Step 2: Verificación de Código -->
                    <form *ngIf="step === 2" #verifyForm="ngForm" (submit)="verifyCode()" class="flex-column">
                        <mat-divider class="my-3"></mat-divider>

                        <div class="text-center mb-4 register-verification-meta">
                            <p class="mat-caption">Hemos enviado un código de verificación a <strong>{{ email }}</strong></p>
                            <p class="mat-caption">Canal de envío actual: <strong>{{ notificationChannel }}</strong></p>
                            <p class="mat-caption">Reenvíos usados: <strong>{{ retryCounter }}</strong>/{{ MAX_RETRY_COUNTER }}</p>
                            @if (lastRegisterMessage) {
                                <p class="mat-caption register-notification-message">{{ lastRegisterMessage }}</p>
                            }
                            @if (retryCounter >= MAX_RETRY_COUNTER) {
                                <p class="mat-caption register-limit-message">Se alcanzó el máximo de reenvíos permitidos.</p>
                            }
                        </div>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Código de Verificación</mat-label>
                            <input matInput type="number" placeholder="Ingrese el código" [(ngModel)]="verificationCode"
                                name="verificationCode" required>
                            <mat-icon matSuffix>verified_user</mat-icon>
                        </mat-form-field>

                        <div class="d-flex justify-center mt-4 gap-2">
                            <button mat-button type="button" (click)="step = 1">Atrás</button>
                            <button mat-button type="button" (click)="resendVerificationCode()" [disabled]="loading || retryCounter >= MAX_RETRY_COUNTER">Reenviar código</button>
                            <button mat-raised-button color="primary" type="submit" class="px-5">Verificar</button>
                        </div>
                    </form>
                </div>
            </div>
        </mat-card-content>
        <mat-card-footer class="p-3 text-sm text-center opacity-25">
            Copyright © <a href="https://ntlink.com.mx" rel="noopener noreferrer" target="_blank" title="NTLINK"
                class="text-reset">NTLINK</a> {{year}} - V {{ version }} - <a
                href="https://ntlink.com.mx/aviso-privacidad" rel="noopener noreferrer" target="_blank"
                title="AVISO DE PRIVACIDAD" class="text-reset">AVISO DE PRIVACIDAD</a>
        </mat-card-footer>
    </mat-card>
</div>